module.exports = __webpack_public_path__ + "img/icon-profile.3b28a937.svg";